const AFFECTED_TIMEZONES = new Set([
  'America/Vancouver',
  'America/Dawson_Creek',
  'America/Fort_Nelson',
  'America/Creston',
  'Canada/Pacific',
  'America/Edmonton',
  'America/Inuvik',
  'America/Yellowknife',
  'Canada/Mountain',
  'America/Winnipeg',
  'Canada/Central',
]);

export const DISMISSED_STORAGE_KEY = 'POD1_3653_TIMEZONE_BANNER_DISMISSED';

export const isAffectedTimezone = (timezone) =>
  Boolean(timezone && AFFECTED_TIMEZONES.has(timezone));

export const isTimezoneBannerDismissed = (userId) => {
  if (!userId) return false;

  try {
    return localStorage.getItem(DISMISSED_STORAGE_KEY) === String(userId);
  } catch (error) {
    return false;
  }
};
